import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { SelectTriggerLabelExtractor } from '@dreryk/react-components';

import { visitTranslationKeys } from '../../../../../../translations';
import { getPractitionerName } from '../../AppointmentForm.utils';

export const usePractitionerTriggerLabelExtractor = (): SelectTriggerLabelExtractor<AppointmentPractitioner> => {
   const translate = useTranslate();
   return (practitioner) => {
      const specialtyNames = practitioner.specialtyNames.length
         ? practitioner.specialtyNames.join(', ')
         : translate(visitTranslationKeys.patient.noSpecialties);

      return `${getPractitionerName(practitioner)}, ${specialtyNames}`;
   };
};
